/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationForAwsKubernetesUserManagedIndividual extends models.StorageConfigurationForAwsKubernetesUserManaged {
    constructor() {
        super();
        this.setDiscriminator("StorageConfigurationForAwsKubernetesUserManagedIndividual");
    }

    getFixupPrototypeFunction() { return StorageConfigurationForAwsKubernetesUserManagedIndividual.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationForAwsKubernetesUserManagedIndividual>): StorageConfigurationForAwsKubernetesUserManagedIndividual {
        let obj = Object.assign(new StorageConfigurationForAwsKubernetesUserManagedIndividual(), model);
        StorageConfigurationForAwsKubernetesUserManagedIndividual.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationForAwsKubernetesUserManagedIndividual>): StorageConfigurationForAwsKubernetesUserManagedIndividual {
        if (!model) return null;
        return StorageConfigurationForAwsKubernetesUserManagedIndividual.newInstance(<StorageConfigurationForAwsKubernetesUserManagedIndividual> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationForAwsKubernetesUserManagedIndividual) {
        if (!obj) return;

        models.StorageConfigurationForAwsKubernetesUserManagedIndividual.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationForAwsKubernetesUserManagedIndividual): boolean {
        if (models.StorageConfigurationForAwsKubernetesUserManaged.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, StorageConfigurationForAwsKubernetesUserManagedIndividual.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
